import { connect } from "react-redux";

import PlayerControls from "./PlayerControls";

import { selectAudioPlaybackRate, selectIsStudentActive, toggleAudioPlaybackRate } from "~/store/ducks/user/uistate";
import { selectDisplayedPages } from "~/store/selectors/page";
import { selectMaterialsByPagesByTypesSorted } from "~/store/ducks/application/materials/materials";

const mapStateToProps = state => {
  const isStudentActive = selectIsStudentActive(state);
  const audioPlaybackRate = selectAudioPlaybackRate(state);
  const pages = selectDisplayedPages(state);
  const materials = selectMaterialsByPagesByTypesSorted(pages)(["directplayer"])(state);
  return { materials, isStudentActive, pages, audioPlaybackRate };
};

const mapDispatchToProps = {
  toggleAudioPlaybackRate
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayerControls);
